MFS = {
    common: {
        init: function () {
            //   replaced in common.init.js
        }
    }
};

DEFINES = {
    siteUrl: "https://" + location.host,
    apiUrl: ab.apiUrl,
    placeholderImageUrl : {
        '50x': "/images/myflashstore/placeholder@50x.png",
        '100x': "/images/myflashstore/placeholder@100x.png",
        '200x': "/images/myflashstore/placeholder@200x.png",
        '300x': "/images/myflashstore/placeholder@300x.png",
        '500x': "/images/myflashstore/placeholder@500x.png"
    }
};

PACKAGE = {
    STARTER : 1,
    BASIC : 2,
    GOLD : 3,
    PLATINUM : 4
};

UTIL = {
    authToken: ab.token,
    authHeader: {
        Authorization: 'Bearer ' + ab.token,
        Accept: "application/json"
    },

    confirmDialog: function(params) {
        buttons = {
            continue: {
                label: "OK",
                className: "btn-primary"
            },
            cancel: {
                label: "Cancel",
                className: "btn-default"
            }
        };

        if (params.type && params.type == 'hard') {
            buttons.continue.className = "btn-danger";
        }

        if (params.confirm !== "" && typeof params.confirm == "function") {
            buttons.continue.callback = params.confirm;
        }

        if (params.cancel !== "" && typeof params.cancel == "function") {
            buttons.cancel.callback = params.cancel;
        }

        bootbox.dialog({
            message: params.message,
            title: params.title,
            buttons: buttons
        });
    },

    registerTask: function (controller, task, callback) {
        var ns = MFS;
        if (controller !== "" && task !== "") {
            if (!ns[controller]) {
                ns[controller] = {
                    init: function () {

                    }
                }
            }
            ns[controller][task] = callback;
        }
    },
    exec: function (controller, task) {
        var ns = MFS,
            action = ( task === undefined ) ? "init" : task;

        if (controller !== "" && ns[controller] && typeof ns[controller][action] == "function") {
            ns[controller][action]();
        }
    },

    init: function () {
        var body = document.body,
            controller = body.getAttribute("data-controller"),
            action = body.getAttribute("data-task");

        UTIL.exec("common");
        UTIL.exec(controller);
        UTIL.exec(controller, action);
    }
};

(function ($) {
    $(document).ready(UTIL.init);
})(jQuery);
